import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";

const CryptoChart = () => {
  const [cryptoData, setCryptoData] = useState([]);
  const [visibleCount, setVisibleCount] = useState(25);

  useEffect(() => {
    fetch(
      "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=250&page=1"
    )
      .then((res) => res.json())
      .then((data) => setCryptoData(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <div className="p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold mb-4">
        Top {visibleCount} Cryptocurrencies
      </h2>

      {/* Table for Crypto Data */}
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">#</th>
              <th className="border p-2">Coin</th>
              <th className="border p-2">Price (USD)</th>
              <th className="border p-2">Market Cap</th>
              <th className="border p-2">24h Volume</th>
              <th className="border p-2">24h Change (%)</th>
            </tr>
          </thead>
          <tbody>
            {cryptoData.slice(0, visibleCount).map((coin, index) => (
              <tr key={coin.id} className="text-center">
                <td className="border p-2">{index + 1}</td>
                <td className="border p-2 flex items-center gap-2">
                  <img src={coin.image} alt={coin.name} className="w-6 h-6" />
                  {coin.name} ({coin.symbol.toUpperCase()})
                </td>
                <td className="border p-2">
                  ${coin.current_price.toLocaleString()}
                </td>
                <td className="border p-2">
                  ${coin.market_cap.toLocaleString()}
                </td>
                <td className="border p-2">
                  ${coin.total_volume.toLocaleString()}
                </td>
                <td
                  className={`border p-2 font-bold ${
                    coin.price_change_percentage_24h >= 0
                      ? "text-green-600"
                      : "text-red-600"
                  }`}
                >
                  {coin.price_change_percentage_24h.toFixed(2)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Price Trends Chart */}
      <div className="mt-6">
        <h3 className="text-lg font-semibold mb-2">Price Trends (USD)</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart
            data={cryptoData
              .slice(0, visibleCount)
              .map((coin) => ({ name: coin.name, price: coin.current_price }))}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="price" stroke="#8884d8" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Show More Button */}
      {visibleCount < cryptoData.length && (
        <div className="text-center mt-6">
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
            onClick={() => setVisibleCount(visibleCount + 25)}
          >
            Show More
          </button>
        </div>
      )}
    </div>
  );
};

export default CryptoChart;
